import useStyles from "../../styles"
import React, { useEffect } from "react"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import { X, ChevronDown } from "lucide-react"
import useMotivoStore from "../../../../stores/motivoStore"

// Componente para o Autocomplete de Motivos
const MotivoAutocomplete = ({ motivoContatoId, onMotivoSelect }) => {
  const classes = useStyles()
  const { motivos, fetchMotivos } = useMotivoStore()

  useEffect(() => {
    fetchMotivos()
  }, [fetchMotivos])

  return (
    <Grid xs={12} item>
      <Autocomplete
        className={classes.autocomplete}
        required
        noOptionsText="Nenhum motivo encontrado"
        fullWidth
        value={motivos.find((m) => m.id === motivoContatoId) || null}
        onChange={(event, newValue) => {
          onMotivoSelect(newValue ? newValue.id : "")
        }}
        popupIcon={<ChevronDown className={classes.iconChevronDown} strokeWidth={2.0} size={"24px"} />}
        closeIcon={<X className={classes.iconX} strokeWidth={2.0} size={"24px"} />}
        options={motivos}
        getOptionLabel={(option) => option.descricao || ""}
        getOptionSelected={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Selecione um Motivo do Contato"
            fullWidth
            required
            InputLabelProps={{
              classes: {
                root: classes.label,
              },
            }}
            InputProps={{
              ...params.InputProps,
              classes: { input: classes.textField },
            }}
          />
        )}
        renderOption={(option, state) => (
          <div key={option.id}>
            <Typography
              component="span"
              style={{
                fontSize: 14,
                marginLeft: "10px",
                display: "inline-flex",
                alignItems: "center",
                lineHeight: "2",
              }}
            >
              {option.descricao}
            </Typography>
          </div>
        )}
      />
    </Grid>
  )
}
export default MotivoAutocomplete
